import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import checkPermisson from '../../helper/check-permission';

const PrivateRoute = ({ component: Component, permissions, ...rest }) => {
  const renderPrivate = (props) => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));

    if (!userInfo || !Array.isArray(userInfo?.permissions))
      return <Redirect to={{ pathname: '/admin/login', state: { from: props.location } }} />;

    if (typeof permissions === 'string' && !checkPermisson(permissions))
      return <Redirect to={{ pathname: '/unauthorized', state: { from: props.location } }} />;

    if (Array.isArray(permissions) && !checkPermisson(permissions))
      return <Redirect to={{ pathname: '/unauthorized', state: { from: props.location } }} />;

    return <Component {...props} />;
  };
  return <Route {...rest} render={renderPrivate} />;
};

PrivateRoute.propTypes = {
  // eslint-disable-next-line react/require-default-props
  permissions: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default PrivateRoute;
